import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=269ac18b&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports